import React from 'react';
import logo from '../../assets/masud-rana-logo.png'

const Loader = () => {
    return (
        <div className="w-2/4 lg:w-1/4 mx-auto mt-64 lg:mt-72">
            <img src={logo} alt="" className=""/>
            <div class="blob">
            
        </div>
        </div>
    );
};

export default Loader;